import { UpdateVersionInfo } from "./UpdateVersionInfo";

export class MachineUpdate {
    /** Nome dell'installazione */
    installationName: string = null;

    /** Serial number della macchina a cui ci si sta riferendo */
    machineSerialNumber: string = null;

    /** Lista dei sws installati con le relative informazioni dettagliate di versione */
    installedSoftwaresVersions: UpdateVersionInfo[] = [];

    /**  Lista dei possibili aggiornamenti per cui manca però l'associazione installazion-pacchetto */
    availableSoftwareVersionsToUpgrade: UpdateVersionInfo[] = [];

    public parse(obj: any) {
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.MachineSerialNumber) this.machineSerialNumber = obj.MachineSerialNumber;

        if (obj.InstalledSoftwaresVersions && obj.InstalledSoftwaresVersions.length > 0) {
            obj.InstalledSoftwaresVersions.forEach((e) => {
                let ms: UpdateVersionInfo = new UpdateVersionInfo();
                ms.parse(e);
                this.installedSoftwaresVersions.push(ms);
            });
        }

        if (obj.AvailableSoftwareVersionsToUpgrade && obj.AvailableSoftwareVersionsToUpgrade.length > 0) {
            obj.AvailableSoftwareVersionsToUpgrade.forEach((e) => {
                let ms: UpdateVersionInfo = new UpdateVersionInfo();
                ms.parse(e);
                this.availableSoftwareVersionsToUpgrade.push(ms);
            });
        }
    }
}
